module.exports = __webpack_public_path__ + "img/file-edit.b132a118.svg";